/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbAttributeMapping {
    getFixupPrototypeFunction() { return ServiceNowCmdbAttributeMapping.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbAttributeMapping>): ServiceNowCmdbAttributeMapping {
        let obj = Object.assign(new ServiceNowCmdbAttributeMapping(), model);
        ServiceNowCmdbAttributeMapping.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbAttributeMapping>): ServiceNowCmdbAttributeMapping {
        if (!model) return null;
        return ServiceNowCmdbAttributeMapping.newInstance(<ServiceNowCmdbAttributeMapping> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbAttributeMapping) {
        if (!obj) return;

        models.ServiceNowCmdbAttributeMapping.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbAttributeMapping): boolean {
        Object.setPrototypeOf(obj, ServiceNowCmdbAttributeMapping.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Column Name in ServiceNow Cmdb table
     */
    target_column: string;

    /**
     * Literal Value
     */
    literal_value: string;

    /**
     * Identifier for the Inventory attribute
     */
    attribute_id: string;

}
